import { ready } from "@devowl-wp/react-utils";
import { CookieConsentManager } from "../apply/manager.js";
import { getUserDecision } from "../decision/getUserDecision.js";
import { BANNER_PRE_DECISION_SHOW_EVENT } from "../events/bannerPredecisionShow.js";
import { BANNER_PRE_DECISION_SHOW_INTERACTIVE_EVENT } from "../events/bannerPredecisionShowInteractive.js";
async function preDecisionGateway(options, handler) {
    const { gateways, args, onIsDoNotTrack, onShowCookieBanner, isInvalidateImplicitUserConsent } = handler;
    let show = true;
    const useOptions = options instanceof CookieConsentManager ? options.getOptions() : options;
    const useOptionsForGateway = {
        ...useOptions,
        getUserDecision: ()=>{
            const decision = getUserDecision(useOptions.decisionCookieName);
            if (decision) {
                // Invalidate when revision changes ("Request new consent")
                if (decision.revision !== useOptions.revisionHash) {
                    return false;
                }
                // Custom invalidation
                if (isInvalidateImplicitUserConsent && decision.buttonClicked?.startsWith("implicit_")) {
                    return false;
                }
            }
            return decision;
        }
    };
    for (const gateway of gateways){
        const result = await gateway(useOptionsForGateway, ...args);
        if (result !== false) {
            show = false;
            const applyWithOptions = (type)=>import(/* webpackChunkName: "banner-lazy", webpackMode: "lazy-once" */ "../apply/apply.js").then(({ apply })=>apply({
                        type,
                        ...useOptions
                    }));
            if (result === "all") {
                applyWithOptions("all");
            } else if (result === "essentials") {
                applyWithOptions("essentials");
            } else if (result === "dnt") {
                onIsDoNotTrack(()=>applyWithOptions("essentials"));
            } else if (result === "consent") {
                // Apply services for the current user decision
                applyWithOptions("consent");
            }
            break;
        }
    }
    if (show) {
        onShowCookieBanner();
        document.dispatchEvent(new CustomEvent(BANNER_PRE_DECISION_SHOW_INTERACTIVE_EVENT));
        // Wait all events are initialized
        await ready();
        document.dispatchEvent(new CustomEvent(BANNER_PRE_DECISION_SHOW_EVENT, {
            detail: {}
        }));
    }
}
export { preDecisionGateway };
